"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _SortControl = _interopRequireDefault(require("./SortControl"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

const CollectionControlsContainer = (0, _styledBase.default)("div", {
  target: "e17kb5zm0",
  label: "CollectionControlsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1ts9nwj",
  styles: "display:grid;gap:1rem;align-items:center;"
} : {
  name: "1ts9nwj",
  styles: "display:grid;gap:1rem;align-items:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

function CollectionControls(_ref) {
  let {
    sortableFields,
    onSortClick,
    sort,
    collectionName
  } = _ref;
  const temp = sortableFields[0];

  for (let i = 1; i < sortableFields.length; i++) {
    sortableFields[i - 1] = sortableFields[i];
  }

  const isTemplates = collectionName.includes("template");
  sortableFields[sortableFields.length - 1] = temp;
  sortableFields.push({
    key: "publish_date",
    label: "Preview",
    name: "publish_date"
  });

  if (sortableFields.find(v => v.label === "Publish Date") === undefined) {
    sortableFields.splice(1, 0, {
      label: "Publish Date",
      date_format: "YYYY-MM-DD",
      format: "YYYY-MM-DD HH:mm",
      key: "date",
      name: "date",
      time_format: "HH:mm",
      widget: "datetime"
    });
  }

  return (0, _core.jsx)(CollectionControlsContainer, {
    style: {
      gridTemplateColumns: `400px 150px repeat(${isTemplates ? '4' : '3'}, 1fr) 30px`
    }
  }, sortableFields.length > 0 && (0, _core.jsx)(_SortControl.default, {
    fields: sortableFields,
    sort: sort,
    onSortClick: onSortClick
  }), (0, _core.jsx)(_react.default.Fragment, null));
}

var _default = CollectionControls;
exports.default = _default;